import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";

@Component({
    selector: 'app-offers',
    templateUrl: './offers.component.html'
})
export class OffersComponent implements OnInit {

    public slug;

    offer = {};

    galleryOptions = [
        {
            width: '600px',
            height: '400px',
            thumbnailsColumns: 4,
        }
    ];
    categories = [];


    galleryImages = [];
    offer_images = [];

    constructor(public share: ShareButtons, private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.getOffer();
        });


        this.getCategories();
    }

    getCategories() {
        this.http.get(Conf.API_URL + '/category-for-offer/?show_all&count=0').subscribe(
            data => {
                this.categories = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getOffer() {
        this.http.get(Conf.API_URL + '/offer/?slug=' + this.slug).subscribe(
            data => {
                if (data['results'].length) {
                    this.offer = data['results'][0];
                } else {
                    this.router.navigateByUrl('/404');
                    return false;
                }
            },
            error => {
                console.log(error.error)
            }
        );
    }


    getOfferImages() {
        this.http.get(Conf.API_URL + '/offer-images/?things_to_do__slug=' + this.slug).subscribe(
            data => {
                this.offer_images = data['results'];

                var this_m = this;

                $.each(this.offer_images, function (index, value) {
                    this_m.galleryImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })

                });

                // console.log(this.galleryImages)
            },
            error => {
                console.log(error.error)
            }
        );
    }


}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/offers/offers.component.ts